export const CUSTOM_POPUP_CONTAINER_ID = 'custom-popup-container';
export const CUSTOM_PICKER_WRAPPER_ID = 'custom-picker-wrapper';
export const RECENT_CUSTOM_DATES_STORAGE_KEY = 'recent-custom-dates';
export const DATE_RANGE_PICKER_CUSTOM_TAB_MESSAGES_TRANSLATED = 'components.form.date_range_picker.tab.custom';

export enum CustomTabSection {
  Custom = 'custom',
  Recent = 'recent',
}

export enum ActivePicker {
  From = 'from',
  To = 'to',
}
